import { Dialog, dialogClasses, type DialogProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { ModalTabbarStoreProvider } from './modal-tabs/ModalTabbarProvider';

const StyledRoot = styled(Dialog)({
  [`.${dialogClasses.paper}`]: {
    height: 'calc(100% - 64px)',
    maxHeight: 944,
  },
}) as typeof Dialog;

export type ModalProps = Omit<DialogProps, 'title'> & {
  onClose?: () => void;
};

export const Modal = (props: ModalProps) => {
  return (
    <ModalTabbarStoreProvider>
      <StyledRoot fullWidth maxWidth="xl" {...props} />
    </ModalTabbarStoreProvider>
  );
};
